import * as React from 'react'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import i18n from 'modules/core/lib/i18n'

const MoreInfo = () => (
  <HelpCenterLink name="subscription_payments">
    {i18n.t('billing.payment.basic_commercial_terms')}
  </HelpCenterLink>
)

export default MoreInfo
